import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'

import { localize } from 'helpers/translator'
import DragPicker from 'components/picker/drag/drag_picker'
import NearpodPickerOptions from 'components/nearpod_picker/components/options/nearpod_picker_options'
import TextLink from 'components/text_link/text_link'

import animation from 'assets/media/animations/circle-drop.json'
import styles from './first_lesson_upload.scss'

class FirstLessonUpload extends PureComponent {

	constructor() {
		super()
		this.acceptedFiles = ['audio', 'gif', 'image', 'pdf', 'ppt', 'google-slides']
	}

	onFilesPicked = file => {
		this.props.firstLessonFilePicked(file)
	}

	onFileError = message => {
		this.props.firstLessonFilePickedError(message)
	}

	render() {
		return (
			<div styleName='wrapper'>
				<div styleName='file-selection'>
					<div styleName='drag-and-drop'>
						<DragPicker
							onChange={this.onFilesPicked}
							accept={this.acceptedFiles}
							dropRejectedHandler={this.onFileError}
							multiselect={false}
							animationData={animation}
							dragDropSegments= {{
								idle: {segment: [0, 15], loop: false},
								active: {segment: [16, 66], loop: true},
							}}
						/>
					</div>
					<span styleName='source-options-or'>{localize('picker_connector_or')}</span>
					<NearpodPickerOptions
						onFilesPicked={this.onFilesPicked}
						accept={this.acceptedFiles}
						onFileError={this.onFileError}
						multiselect={false}
					/>
				</div>
				<div styleName='link-container'>
					<TextLink onClick={this.props.firstLessonClosed}>
						{localize('first_lesson_overlay_secondary_text_button')}
					</TextLink>
				</div>
			</div>
		)
	}
}

FirstLessonUpload.propTypes = {
	firstLessonFilePicked: PropTypes.func,
	firstLessonFilePickedError: PropTypes.func,
	firstLessonClosed: PropTypes.func,
}

FirstLessonUpload.defaultProps = {
	firstLessonFilePicked: () => {},
	firstLessonFilePickedError: () => {},
	firstLessonClosed: () => {},
}

export default CSSModules(FirstLessonUpload, styles, {allowMultiple: true})
